<template>
  <div class="container">
    <div class="content-box">
      <div class="left-box">
        <ModelList :modelsList="modelsList" @chooseModel="chooseModel" :modelChooseIdx="modelChooseIdx"></ModelList>
      </div>
      <div class="center-box">
        <div class="center-default-box" ref="mainScroll">
          <div v-show="!isLoading" class="problem-wrap" v-for="(item,idx) in problemDefalutList1" :key="idx">
            <ProblemOne v-if="item.type == 1 && careerChooseIdx <= 0" :problemItem="item" :problemIdx="idx"
              @changeIdx="changeDefaultIdx"></ProblemOne>
            <ProblemTwo v-if="item.type == 2 && !modelChooseIdx" :problemItem="item" :problemIdx="idx"
              @changeIdx="changeDefaultIdx"></ProblemTwo>
          </div>
          <div v-if="chatItem && problemList.length == 0">
            <div class="problem-wrap" v-for="(item,idx) in problemTips" :key="idx">
              <TipItem :problemItem="item" :problemIdx="idx" @changeTipIdx="changeTipIdx" @refresh="refresh"
                :chatItem="chatItem" @sumbitTipFun="sumbitTipFun" :currentTypeItem="currentTypeItem">
              </TipItem>
            </div>
          </div>
          <div class="problem-wrap" v-for="(problemItem,problemIdx) in problemList" :key="problemItem.id">
            <AnswerCom v-if="problemItem.type == 1 || problemItem.cat == 1" :problemItem="problemItem"
              :problemIdx="problemIdx" @showZhuanFa="showZhuanFa" @chooseZhuanfa="chooseZhuanfa"
              :streamStatus="streamStatus" @isEnd="isEnd"></AnswerCom>
            <ProblemThree v-if="problemItem.type == 3 || problemItem.cat == 0" :problemItem="problemItem"
              :problemIdx="problemIdx" @chooseZhuanfa="chooseZhuanfa" :userInfo="userInfo" :streamStatus="streamStatus">
            </ProblemThree>
          </div>
          <div class="problem-wrap" v-if="calAnswer()">
            <!-- <div class="problem-wrap"> -->
            <ProblemInput :chatItem="chatItem">
            </ProblemInput>
          </div>
          
          <div class="zhuanfa-popup flex justify-between" v-if="zhuanFaShow">
            <div class="cancel-normal-btn" @click="zhuanFaCancel">取消</div>
            <div class="submit-normal-btn" @click="goZhuanfa">确定</div>
          </div>
          <ZhuanFa class="content-detail-popup" :zhuanfaMessageIds="zhuanfaMessageIds" :zhuanfaName="zhuanfaName"
            :currentChatId="currentChatId" v-if="showZhuanfaPopup" @closeZhuanfa="showZhuanfaPopup = false"
            @showPayEmit="showPayEmit"></ZhuanFa>
        </div>
        <div class="bottom-fixed" v-show="showCyAsk">
          <AskCom @closePopup="closePopup" :chatItem="chatItem" :currentTypeItem="currentTypeItem"
            @hideContentEditFun="hideContentEditFun"></AskCom>
        </div>
      </div>
      <div class="right-box">
        <ChatHistory :statusLoadmore="statusLoadmore" :historyList="historyList" :currentIdx="currentIdx"
          @delHistory="delHistory" @getChatMessage="getChatMessage" @goCreate="goCreate" @loadMoreData="loadMoreData">
        </ChatHistory>
      </div>
    </div>

    <RewardCom v-if="showReward" @closeRewardPopup="closeRewardPopup"></RewardCom>
    <StationList v-if="showStationList" @closeStation="showStationList = false" @goPay="goPay">
    </StationList>
    <PayCom v-if="showPay" @closePay="closePay" :payInfo="payInfo" :orderCurrentInfo="orderInfo"></PayCom>
  </div>
</template>
<script>
  import HeaderTop from "@/components/headerTop/index.vue";
  import MenuCom from "@/components/menu/index.vue";
  import ModelList from "@/components/modelList/index.vue";
  import CenterDefault from "@/components/centerDefault/index.vue";
  import ChatHistory from "@/components/chatHistory/index.vue";
  import LoginRegister from "@/components/login/index.vue";
  import ProblemOne from "@/components/problem/problemOne.vue";
  import ProblemTwo from "@/components/problem/problemTwo.vue";
  import AskCom from "@/components/ask/index.vue";
  import TipItem from "@/components/home/tipItem.vue";
  import RewardCom from "@/components/home/reward.vue";
  import ProblemInput from "@/components/home/problemInput.vue";
  import AnswerCom from "@/components/home/answer.vue";
  import ProblemThree from "@/components/home/problemThree.vue";
  import ZhuanFa from "@/components/home/zhuanfa.vue";
  import PayCom from "@/components/pay/index.vue";
  import StationList from "@/components/user/station.vue";
  import {
    getChatModels,
    createChat,
    closeChat,
    getChatTipMessages,
    getChatList,
    deleteChat,
    getChatMessages
  } from "@/api/chat";
  import { getDefaultConfig, userUpdateProfile } from "@/api/user";
  import util from "@/utils/util";
  import { getToken } from "@/utils/auth";
  import { v4 as uuid } from "uuid";
  import * as protobuf from "protobufjs";
  import { pb } from "@/utils/pb/chat_es6.js";
  import { MessageBox } from "element-ui";
  export default {
    components: {
      HeaderTop,
      MenuCom,
      ModelList,
      CenterDefault,
      ChatHistory,
      LoginRegister,
      ProblemOne,
      ProblemTwo,
      AskCom,
      TipItem,
      RewardCom,
      ProblemInput,
      AnswerCom,
      ProblemThree,
      ZhuanFa,
      PayCom,
      StationList,
    },
    data() {
      return {
        showStationList: false,
        showPay: false,
        payInfo: null,
        showLogin: false,
        isLoading: false,
        problemDefalutList1: [
          {
            type: 1,
            name: "您好，我是您的育儿智能工具，随时准备为您提供专业的育儿建议和支持。",
            desc: "请告诉我您的身份？",
            status: 1,
            chooseIdx: -1,
            children: [
              {
                id: 1,
                name: "我是家长",
                type: "parent",
              },
              {
                id: 2,
                name: "我是玩具设计师",
                type: "toy_designer",
              },
              {
                id: 3,
                name: "我是教育工作者",
                type: "educator",
              },
              {
                id: 4,
                name: "我是医生/心理学家",
                type: "psychologist",
              },
              {
                id: 5,
                name: "其他",
                type: "other",
              },
            ],
          },
        ],
        chatItem: null,
        problemTips: [
          {
            type: 1,
            name: "",
            desc: "",
            status: 1,
            chooseIdx: -1,
            showMore: true,
            showGuide: true,
            children: [],
          },
        ],
        problemList: [],
        problemList1: [
          {
            chatId: "666fe468274819f8224d76b2",
            chooseIdx: 0,
            dataTime: 1718609002526,
            desc: "儿童教育",
            id: "acdb8165-dc75-4d25-9e96-dc0cc3ae1d2f",
            showBottom: false,
            showMore: false,
            showZhuanFa: false,
            status: 1,
            type: 3,
          },
          {
            chatId: "666fe468274819f8224d76b2",
            chooseIdx: 0,
            dataTime: 1718609004000,
            desc: [
              {
                descId: uuid(),
                info: "您好，我是您的育儿智能工具，随时准备为您提供专业的育儿建议和支持。您好，我是您的育儿智能工具，随时准备为您提供专业的育儿建议和支持。您好，我是您的育儿智能工具，随时准备为您提供专业的育儿建议和支持。您好，我是您的育儿智能工具，随时准备为您提供专业的育儿建议和支持。您好，我是您的育儿智能工具，随时准备为您提供专业的育儿建议和支持。您好，我是您的育儿智能工具，随时准备为您提供专业的育儿建议和支持。您好，我是您的育儿智能工具，随时准备为您提供专业的育儿建议和支持。您好，我是您的育儿智能工具，随时准备为您提供专业的育儿建议和支持。您好，我是您的育儿智能工具，随时准备为您提供专业的育儿建议和支持。您好，我是您的育儿智能工具，随时准备为您提供专业的育儿建议和支持。您好，我是您的育儿智能工具，随时准备为您提供专业的育儿建议和支持。您好，我是您的育儿智能工具，随时准备为您提供专业的育儿建议和支持。您好，我是您的育儿智能工具，随时准备为您提供专业的育儿建议和支持。您好，我是您的育儿智能工具，随时准备为您提供专业的育儿建议和支持。您好，我是您的育儿智能工具，随时准备为您提供专业的育儿建议和支持。您好，我是您的育儿智能工具，随时准备为您提供专业的育儿建议和支持。您好，我是您的育儿智能工具，随时准备为您提供专业的育儿建议和支持。您好，我是您的育儿智能工具，随时准备为您提供专业的育儿建议和支持。您好，我是您的育儿智能工具，随时准备为您提供专业的育儿建议和支持。您好，我是您的育儿智能工具，随时准备为您提供专业的育儿建议和支持。",
              },
            ],

            id: "a8930a85-6dee-46bd-98e5-0fe578bd68fc",
            imageSrc: [],
            showBottom: true,
            showMore: false,
            showZhuanFa: false,
            status: 2,
            type: 1,
          },
          {
            chatId: "666fe468274819f8224d76b2",
            chooseIdx: 0,
            dataTime: 1718609004000,
            desc: [
              {
                descId: uuid(),
                info: "您好，我是您的育儿智能工具，随时准备为您提供专业的育儿建议和支持。您好，我是您的育儿智能工具，随时准备为您提供专业的育儿建议和支持。您好，我是您的育儿智能工具，随时准备为您提供专业的育儿建议和支持。您好，我是您的育儿智能工具，随时准备为您提供专业的育儿建议和支持。您好，我是您的育儿智能工具，随时准备为您提供专业的育儿建议和支持。您好，我是您的育儿智能工具，随时准备为您提供专业的育儿建议和支持。您好，我是您的育儿智能工具，随时准备为您提供专业的育儿建议和支持。您好，我是您的育儿智能工具，随时准备为您提供专业的育儿建议和支持。您好，我是您的育儿智能工具，随时准备为您提供专业的育儿建议和支持。您好，我是您的育儿智能工具，随时准备为您提供专业的育儿建议和支持。您好，我是您的育儿智能工具，随时准备为您提供专业的育儿建议和支持。您好，我是您的育儿智能工具，随时准备为您提供专业的育儿建议和支持。您好，我是您的育儿智能工具，随时准备为您提供专业的育儿建议和支持。您好，我是您的育儿智能工具，随时准备为您提供专业的育儿建议和支持。您好，我是您的育儿智能工具，随时准备为您提供专业的育儿建议和支持。您好，我是您的育儿智能工具，随时准备为您提供专业的育儿建议和支持。您好，我是您的育儿智能工具，随时准备为您提供专业的育儿建议和支持。您好，我是您的育儿智能工具，随时准备为您提供专业的育儿建议和支持。您好，我是您的育儿智能工具，随时准备为您提供专业的育儿建议和支持。您好，我是您的育儿智能工具，随时准备为您提供专业的育儿建议和支持。",
              },
            ],

            id: "a8930a85-6dee-46bd-98e5-0fe578bd68fc",
            imageSrc: [],
            showBottom: true,
            showMore: false,
            showZhuanFa: false,
            status: 2,
            type: 1,
          },
          {
            chatId: "666fe468274819f8224d76b2",
            chooseIdx: 0,
            dataTime: 1718609004000,
            desc: [
              {
                descId: uuid(),
                info: "您好，我是您的育儿智能工具，随时准备为您提供专业的育儿建议和支持。您好，我是您的育儿智能工具，随时准备为您提供专业的育儿建议和支持。您好，我是您的育儿智能工具，随时准备为您提供专业的育儿建议和支持。您好，我是您的育儿智能工具，随时准备为您提供专业的育儿建议和支持。您好，我是您的育儿智能工具，随时准备为您提供专业的育儿建议和支持。您好，我是您的育儿智能工具，随时准备为您提供专业的育儿建议和支持。您好，我是您的育儿智能工具，随时准备为您提供专业的育儿建议和支持。您好，我是您的育儿智能工具，随时准备为您提供专业的育儿建议和支持。您好，我是您的育儿智能工具，随时准备为您提供专业的育儿建议和支持。您好，我是您的育儿智能工具，随时准备为您提供专业的育儿建议和支持。您好，我是您的育儿智能工具，随时准备为您提供专业的育儿建议和支持。您好，我是您的育儿智能工具，随时准备为您提供专业的育儿建议和支持。您好，我是您的育儿智能工具，随时准备为您提供专业的育儿建议和支持。您好，我是您的育儿智能工具，随时准备为您提供专业的育儿建议和支持。您好，我是您的育儿智能工具，随时准备为您提供专业的育儿建议和支持。您好，我是您的育儿智能工具，随时准备为您提供专业的育儿建议和支持。您好，我是您的育儿智能工具，随时准备为您提供专业的育儿建议和支持。您好，我是您的育儿智能工具，随时准备为您提供专业的育儿建议和支持。您好，我是您的育儿智能工具，随时准备为您提供专业的育儿建议和支持。您好，我是您的育儿智能工具，随时准备为您提供专业的育儿建议和支持。",
              },
            ],

            id: "a8930a85-6dee-46bd-98e5-0fe578bd68fc",
            imageSrc: [],
            showBottom: true,
            showMore: false,
            showZhuanFa: false,
            status: 2,
            type: 1,
          },
        ],
        showReward: false,
        showLayer: false,
        defaultConfig: null,
        userInfo: {
          id: "",
          nickname: "",
          mobile: "",
          avatar: "",
          gender: "",
          desc: "",
          real_name: "",
          character: "",
          vip_level: 0,
          vip_expires_in: "",
          coin: 0,
          income: 0,
          balance: 0,
          freeze: 0,
          token: "",
        },
        socketTask: null,
        modelsList: [],
        streamStatus: -1,
        tempItem: null,
        showModal: false,
        modelIdx: -1,
        currentTypeItem: null,
        modelChooseIdx: "",
        careerChooseIdx: localStorage.getItem("careerChooseIdx") || -1,
        isGetMessage: false,
        connectInter: null,
        showPayModal: false,
        messageList: [],
        currentChatMessageItem: null,
        messageParams: {
          offset: 0,
          pageSize: 0,
          limit: 20,
        },
        params: {
          offset: 0,
          limit: 100,
        },
        tempProblemList: [],
        showAsk: false,
        showCyAsk: false,
        historyList: [],
        currentIdx: -1,
        historyParams: {
          offset: 0,
          pageSize: 0,
          limit: 20,
        },
        delItem: null,
        timer: null,
        isCanClick: true,
        messages: [],
        currentMessage: null,
        isOpen: false,
        isSend: false,
        isFirst: true,
        isClose: false,
        zhuanFaShow: false,
        zhuanfaMessageIds: null,
        zhuanfaName: null,
        currentChatId: null,
        showZhuanfaPopup: false,
        statusLoadmore: "loadmore",
        messageParams: {
					offset: 0,
					pageSize: 0,
					limit: 100
				},
        orderInfo: null
      };
    },
    created() {
      this.historyParams.offset = 0;
      this.historyParams.pageSize = 0;

      util.onLogin().then((res) => {
        if (!res) {
          this.$bus.$emit("openLogin");
        } else {
          this.getDefaultConfigReq();
          this.getUserInfo();
          this.getChatListReq();
        }
      });

      this.$bus.$off("initData");
      this.$bus.$on("initData", () => {
        this.getDefaultConfigReq();
        this.getUserInfo();
        this.getChatListReq();
      });

      this.$bus.$off("paySuccess");
      this.$bus.$on("paySuccess",() => {
        this.showStationList = false;
        this.getUserInfo(true);
      })
    },
    beforeDestroy() {
      this.socketTask && this.socketTask.close();
      this.timer && clearInterval(this.timer);
      this.connectInter && clearInterval(this.connectInter);
    },
    methods: {
      getChatMessage(val) {
        let item = val.item || null;
        this.currentIdx = val.idx || -1;
				if(item && item.id) {
					this.isGetMessage = true;
					this.messageParams["offset"] = 0;
					this.messageParams["id"] = item.id;
					this.currentChatMessageItem = item;
					this.messageList = [];
					this.problemList = [];
					this.chatItem = item;
					
					
					this.getChatMessagesReq();
				}
			},
			getChatMessagesReq() {
				getChatMessages({
          id:this.messageParams.id,
          offset: this.messageParams.offset,
          limit: this.messageParams.limit
        }).then((res) => {
					console.log("getChatMessages-res",res)
					if(res && res.data && res.data.list && res.data.list.length > 0) {
            let list = res.data.list;
						list = list.reverse();
						list.forEach(messageItem => {
							const isExist = this.messageList.find((item) => item.message_id === messageItem.message_id);
							if(isExist) {
								return;
							} else {
								this.messageList.push(messageItem);
							}
							
						});
						// this.problemList = this.messageList;
						for(let i = 0,j= list.length;i<j;i++) {
							let tempItem = list[i];
							if(tempItem.cat == 0) {
								let msgItem = {
									type: 3,
									desc: tempItem.msg && tempItem.msg.text || "",
									imageSrc: tempItem.msg && tempItem.msg.image || "",
									status: 1,
									chooseIdx: 0,
									showMore: false,
									showBottom: false,
									dataTime: tempItem.created_at && new Date(tempItem.created_at).getTime(),
									id: tempItem.message_id,
									chatId: this.chatItem.id
								}
								this.problemList.push(msgItem)
							} else {
								let msgLeftItem = {
									type: 1,
									desc: [],
									imageSrc: [],
									status: 0,
									chooseIdx: 0,
									showMore: false,
									showBottom: true,
									dataTime: tempItem.created_at && new Date(tempItem.created_at).getTime(),
									id: tempItem.message_id,
									chatId: this.chatItem.id,
									isMessage: true
								}
								
								console.log("tempItem",tempItem)
								if((tempItem.msg && tempItem.msg.text) || (tempItem.msg && tempItem.msg.image)) {
									if(tempItem.msg && tempItem.msg.text) {
										let tempText = {
											info: tempItem.msg.text,
											descId: uuid()
										}
										msgLeftItem.desc.push(tempText);
									}
									if(tempItem.msg && tempItem.msg.image) {
										msgLeftItem.imageSrc.push(tempItem.msg.image);
									}
									this.problemList.push(msgLeftItem);

								}
								
							}
							
							
						}
					}
					this.initModel(this.chatItem && this.chatItem.type);
					let isExist = this.modelsList.filter((res) => {
						return res.type == this.currentChatMessageItem.type && res.model == this.currentChatMessageItem.model;
					})
					console.log("isExist",isExist)
					if(isExist && isExist.length > 0 && this.problemList.length == 0) {
						this.modelChooseIdx = isExist[0].id;
						console.log("modelChooseIdx",this.modelChooseIdx)
						localStorage.setItem("modelChooseIdx",this.modelChooseIdx)
						let idx = this.modelsList.findIndex((res) => {
							return res.id == this.modelChooseIdx;
						})
						this.problemDefalutList1[1]["chooseIdx"] = Number(idx);
						
						this.typeIdx = Number(idx);
						this.currentTypeItem = this.modelsList[idx];
						console.log("idx",idx,"currentTypeItem",this.currentTypeItem)
					  localStorage.setItem("currentMsg","");
						localStorage.setItem("currentChatItem","");

						if (this.chatItem && (this.chatItem.type == 0 || this.chatItem.type == 1)) {
							this.getChatTipMessagesReq();
						}
						if(this.chatItem && this.chatItem.id) {
						
							this.$bus.$emit("initDefault",{
								desc: "",
								hash: "",
								imageSrc:""
							})
						}
					}
					this.toBottom();
				}).catch((err)=> {
					this.$message({
						message: err && err.msg || "服务器异常，请稍后重试",
						type: "error"
					});
				})
			},
      isEnd() {
        this.toBottom()
      },
      closePopup() {
        this.showCyAsk = false;
      },
      hideContentEditFun(param) {
				if (this.streamStatus >= 0 && this.streamStatus != 4) {
					this.$message({
						message: "您已经提问，请等待回复!",
						type: "info"
					});
					return;
				}
				// if(this.currentTypeItem && (this.currentTypeItem.type == 4 || this.currentTypeItem.type == 5)) {
				// 	this.sendMessage(param.text,param.image,param.imageSrc)
				// }
				// if(this.currentTypeItem && this.currentTypeItem.type == 3) {
				// 	this.sendMessage("",param.image,param.imageSrc)
				// }
				this.sendMessage(param.text,param.image,param.imageSrc)
				this.toBottom();
			},
      showPayEmit() {
        this.showStationList = true;
      },
      goPay(item) {
        this.payInfo = item;
        this.orderInfo = null;
        this.showPay = true;
      },
      closePay() {
        this.showPay = false;
      },
      zhuanFaCancel() {
        let tempList = JSON.parse(JSON.stringify(this.problemList));
        for (let i = 0, j = tempList.length; i < j; i++) {
          let item = tempList[i];
          item["showZhuanFa"] = false;
        }
        this.problemList = tempList;
        this.zhuanFaShow = false;
        this.initModel(this.chatItem && this.chatItem.type);
      },
      goZhuanfa() {
        let chooseItems = [];
        chooseItems = this.problemList.filter((res) => {
          return res["zhuanFaChoose"] == true;
        });
        if (!chooseItems) {
          this.$message({
            message: "暂未选择转发内容，请选择!",
            type: "error",
          });
          return;
        }
        let chatId = "";
        let messageIds = [];
        let name = "";
        if (this.isGetMessage) {
          chatId = this.currentChatMessageItem.id;
          let tempItem = this.modelsList.filter((res) => {
            return (
              res.model == this.currentChatMessageItem.model &&
              this.currentChatMessageItem.type == res.type
            );
          });
          if (tempItem && tempItem.length > 0) {
            name = tempItem[0].name;
          }
        } else {
          name = this.currentTypeItem.name;
        }
        for (let i = 0, j = chooseItems.length; i < j; i++) {
          let tempItem = chooseItems[i];
          if (i == 0 && !this.isGetMessage) {
            chatId = tempItem.chatId;
          }
          messageIds.push(tempItem.id);
        }
        console.log("messageIds", messageIds.join(","));
        this.zhuanfaMessageIds = messageIds.join(",");
        this.zhuanfaName = name;
        this.currentChatId = chatId;
        this.zhuanFaShow = false;
        this.showZhuanfaPopup = true;
        // uni.navigateTo({
        // 	url: "/pages/zhuanfa/zhuanfa?chatId=" + chatId + "&messageIds="+ encodeURI(messageIds.join(",")) +"&name=" + name
        // })
      },
      showZhuanFa() {
        let tempList = JSON.parse(JSON.stringify(this.problemList));
        for (let i = 0, j = tempList.length; i < j; i++) {
          let item = tempList[i];
          item["showZhuanFa"] = true;
        }
        this.problemList = tempList;
        this.zhuanFaShow = true;
        this.showAsk = false;
        this.showCyAsk = false;
      },
      chooseZhuanfa(item) {
        if (item && item.type) {
          let tempList = JSON.parse(JSON.stringify(this.problemList));
          let tempItem = tempList[item.idx];
          tempItem["zhuanFaChoose"] = item.type == 1 ? false : true;
          this.problemList = tempList;
        }
      },
      calAnswer() {
        const isExist = this.problemList.filter((item) => {
          return item.type == 1;
        });
        const isExist1 = this.problemList.filter((item) => {
          return item.type == 3;
        });
        if (isExist && isExist.length > 0) {
          return false;
        } else if (isExist1 && isExist1.length > 0) {
          return true;
        }
      },
      loadMoreData() {
        this.statusLoadmore = "loading";
        this.historyParams.pageSize += 1;
        this.historyParams.offset = (this.historyParams.pageSize + 1) * this.historyParams.limit;
        console.log("more");
        this.getChatListReq();
      },
      getChatListReq() {
        getChatList(this.historyParams)
          .then((res) => {
            if (res && res.error == 0) {
              if (res && res.data && res.data.list) {
                res.data.list.forEach((billItem) => {
                  const isExist = this.historyList.find(
                    (item) => item.id === billItem.id
                  );
                  if (isExist) {
                    return;
                  } else {
                    this.historyList.push(billItem);
                  }
                });
                if (res && res.data && res.data.has_more) {
                  this.statusLoadmore = "loadmore";
                } else {
                  this.statusLoadmore = "nomore";
                }
              } else {
                this.statusLoadmore = "loadmore";
              }

            }
          })
          .catch(() => {
            this.statusLoadmore = "loadmore";
          });
      },
      delHistory(val) {
        deleteChat({ id: val.item.id })
          .then((res) => {
            if (res && res.error == 0) {
              this.$message({
                message: "删除消息成功",
                type: "success",
              });
              this.historyList.splice(val.idx, 1);
              this.currentIdx = -1;
              this.getChatListReq();
            } else {
              this.$message({
                message: (res && res.msg) || "服务器异常，请稍后重试",
                type: "error",
              });
            }
          })
          .catch((err) => {
            this.$message({
              message: (err && err.msg) || "服务器异常，请稍后重试",
              type: "error",
            });
          });
      },
      goCreate() {
        if (!this.currentTypeItem) {
          this.$message({
            message: "请选择模型",
            type: "error",
          });
          return;
        }
        localStorage.setItem(
          "modelChooseIdx",
          (this.currentTypeItem && this.currentTypeItem.id) || ""
        );
        this.modelChooseIdx = localStorage.getItem("modelChooseIdx") || "";
        this.initChat();
        this.toBottom();
      },
      showFullLayer(val) {
        this.showLayer = val;
      },
      closeLogin() {
        this.showLogin = false;
      },
      goLogin() {
        this.showLogin = true;
      },
      changeDefaultIdx() {
        this.isGetMessage = false;

        userUpdateProfile({
          character:
            this.problemDefalutList1[val.problemIdx].children[val.idx].type,
        }).then((res) => {
          console.log("userUpdateProfile", res);
        });
        this.problemDefalutList1[val.problemIdx]["chooseIdx"] = val.idx;
        localStorage.setItem("careerChooseIdx", val.idx + 1);
        this.careerChooseIdx = localStorage.getItem("careerChooseIdx") || -1;
        this.problemDefalutList1[1] = {
          type: 2,
          desc: "请在助手列表中，选择对应的助手",
          chooseIdx: -1,
          children: [],
        };
        this.getChatModelsReq();
      },
      sumbitTipFun(val) {
        if (val) {
          if (this.streamStatus >= 0 && this.streamStatus != 4) {
            this.$message({
              message: "您已经提问，请等待回复!",
              type: "warning",
            });
            return;
          }
          this.problemDefalutList1[1]["chooseIdx"] = -1;
          if (this.chatItem && this.chatItem.id) {
            this.sendMessage(val);
          }
          this.toBottom();
        }
      },
      refresh() {
        this.getChatTipMessagesReq();
      },
      changeTipIdx(val) {
        console.log(
          "changeTipIdx",
          val,
          "streamStatus",
          this.streamStatus,
          "chatItem",
          this.chatItem
        );
        if (this.streamStatus >= 0 && this.streamStatus != 4) {
          this.$message({
            message: "您已经提问，请等待回复!",
            type: "warning",
          });
          return;
        }
        this.problemTips[val.problemIdx]["chooseIdx"] = val.idx;
        if (this.chatItem && this.chatItem.id) {
          this.sendMessage(val.msg);
        }

        this.toBottom();
      },
      closeRewardPopup() {
        this.showReward = false;
      },
      getChatModelsReq(modelChooseIdx = -1) {
        getChatModels(this.params)
          .then((res) => {
            if (res && res.error == 0) {
              this.modelsList = (res.data && res.data.list) || [];
              // this.problemDefalutList1[1].children = this.modelsList;
              let careerChooseIdx = localStorage.getItem("careerChooseIdx");
              if (careerChooseIdx && careerChooseIdx > 0) {
                this.problemDefalutList1[0]["chooseIdx"] =
                  Number(careerChooseIdx) - 1;
              }
              modelChooseIdx =
                modelChooseIdx >= 0
                  ? modelChooseIdx
                  : localStorage.getItem("modelChooseIdx");
              console.log("modelChooseIdx", modelChooseIdx);
              if (modelChooseIdx) {
                this.modelChooseIdx = modelChooseIdx;
                let idx = this.modelsList.findIndex((res) => {
                  return res.id == modelChooseIdx;
                });
                console.log("idx", idx);
                // this.problemDefalutList1[1]["chooseIdx"] = Number(idx);
                this.modelIdx = Number(idx);
                this.currentTypeItem = this.modelsList[idx];
                let currentMessage = localStorage.getItem("currentMsg");
                let currentChatItem = localStorage.getItem("currentChatItem");
                if (currentMessage && currentChatItem) {
                  currentMessage = JSON.parse(currentMessage);
                  currentChatItem = JSON.parse(currentChatItem);
                  if (
                    this.currentTypeItem.type == currentChatItem.type &&
                    this.currentTypeItem.model == currentChatItem.model
                  ) {
                    localStorage.setItem("currentMsg", "");
                    localStorage.setItem("currentChatItem", "");
                    this.chatItem = currentChatItem;
                    console.log(
                      "currentMessage",
                      currentMessage,
                      "currentChatItem",
                      currentChatItem
                    );
                    this.initModel(currentChatItem.type);
                    if (
                      currentChatItem &&
                      (currentChatItem.type == 0 || currentChatItem.type == 1)
                    ) {
                      this.getChatTipMessagesReq();
                    }
                    if (this.chatItem && this.chatItem.id) {
                      this.$bus.$emit("initDefault", {
                        desc: currentMessage.desc || "",
                        hash: currentMessage.image || "",
                        imageSrc: currentMessage.imageSrc || "",
                      });
                      // this.sendMessage(currentMessage.desc || "",currentMessage.image || "",currentMessage.imageSrc || "",currentMessage.id || "");
                    }
                  }
                } else {
                  if (!this.isGetMessage) {
                    this.initChat();
                  }
                }
                this.toBottom();
              }
            }
          })
          .catch(() => { });
      },
      getDefaultConfigReq() {
        getDefaultConfig()
          .then((res) => {
            if (res && res.error == 0) {
              this.defaultConfig = res.data || null;
            }
          })
          .catch(() => { });
      },
      getUserInfo(isRefresh = false) {
        this.$store
          .dispatch("GetInfo", "")
          .then((res) => {
            this.userInfo = res;
            console.log("isRefresh", isRefresh);
            if (!isRefresh) {
              this.initChatModal();
              this.connectSocket();
            }
          })
          .catch((err) => { });
      },
      //连接websocket
      connectSocket() {
        let that = this;
        console.log("调用连接websocket");
        let authorization = `Bearer ${getToken()}`;
        that.socketTask = new WebSocket(
          "wss://dev.sssrise.com/ai/ws?user_id=" +
          (that.userInfo && that.userInfo.id) +
          "&dev_id=asdf&app_id=1&authorization=" +
          authorization
        );
        that.socketTask.binaryType = "arraybuffer"; // 设置接收二进制数据
        that.socketTask.onopen = () => {
          console.log("WebSocket connected");
          that.isOpen = true;
          that.isClose = false;
          that.heart();
        };
        that.socketTask.onmessage = (res) => {
          console.log("收到服务器内容：" + res.data);
          let packet = pb.Packet.decode(new Uint8Array(res.data));
          console.log("packet", packet);
          let message = packet.msg;
          console.log(message, "received");
          
          if (
            message &&
            message.user &&
            message.user.id &&
            message.user.id == that.userInfo.id &&
            message.ack &&
            message.ack.messageId &&
            message.cmd == 3
          ) {
            that.isCanClick  = true;
            console.log("tempProblemList", that.tempProblemList);
            if (that.tempProblemList && that.tempProblemList.length > 0) {
              let isExist = that.tempProblemList.find(
                (item) =>
                  item.id === message.ack.messageId &&
                  item.chatId == message.chatId
              );
              console.log("isExist", isExist);
              if (isExist) {
                const isExist1 = that.problemList.find(
                  (item) =>
                    item.id === isExist.id && item.chatId == isExist.chatId
                );
                console.log("isExist1", isExist1);
                if (!isExist1) {
                  that.addData(that.tempProblemList[0]);
                  that.$bus.$emit("clearText");
                }
              }
            }
          }
          if (
            message &&
            message.ai &&
            message.ai.stream &&
            message.ai.stream.status &&
            message.ai.stream.status == 4 &&
            that.chatItem &&
            that.chatItem.id == message.chatId &&
            message.cmd == 1
          ) {
            that.isCanClick  = true;
            that.streamStatus = message.ai.stream.status;
            // that.chatItem = null;
            that.$message({
              message: "回复完成，您可以继续提问了",
              type: "success",
            });
          }
          console.log("that.problemList", that.problemList);
          // if (message && (message.cmd == 1 || (message.ai && message.ai.id && message.ai.model)) && that.chatItem &&  that.chatItem.id == message.chatId && message.cmd != 4) {
          if (
            message &&
            message.cmd == 1 &&
            that.chatItem &&
            that.chatItem.id == message.chatId &&
            message.ai.stream &&
            message.ai.stream.status &&
            message.ai.stream.status != 4 &&
            message.ai.stream.status != 1 &&
            message.ai.stream.status != 3
          ) {
            that.isCanClick  = true;
            that.addData1(message, 1);
          }
          if (
            message &&
            !message.cmd &&
            that.chatItem &&
            that.chatItem.id == message.chatId
          ) {
            that.isCanClick  = true;
            that.addData1(message, 2);
          }
          if(packet && packet.cmd == 4) {
						if(packet.api && packet.api.data) {
							let resData = JSON.parse(packet.api.data) || null;
							console.log("resData",resData)
							if(resData && resData.current_coin) {
								that.$set(that.userInfo,"coin",resData.current_coin)
							} else if(resData && resData.current_cion == 0) {
								that.$set(that.userInfo,"coin",0)
							}
						}
						
						setTimeout(() => {
              that.$bus.$emit("refreshHeaderUser");
							that.getUserInfo(true);
						},2000);
					}
        };

        that.socketTask.onerror(function (res) {
          console.log("WebSocket连接打开失败，请检查！");
          console.log(res);
          that.isOpen = false;
          if (that.socketTask) {
            that.socketTask.close();
          }
          //进入重新连接
          that.socketTask = null;
          clearInterval(that.timer);

          if (that.connectNum < 6) {
            // uni.showToast({
            // 	title: `WebSocket连接失败，正尝试第${that.connectNum}次连接`,
            // 	icon: "none"
            // })
            that.reconnect();
            that.connectNum += 1;
          } else {
            that.connectNum = 1;
          }
        });
        // 监听连接关闭 -
        that.socketTask.onclose((e) => {
          console.log("WebSocket连接关闭！");
          this.isOpen = false;
          clearInterval(that.timer);
          that.timer = "";
          if (that.socketTask) {
            that.socketTask.close();
          }
          that.socketTask = null;
          if (this.connectNum < 6) {
            if (!that.connectInter) {
              that.connectInter = setInterval(() => {
                that.reconnect();
              }, 2000);
            }
          } else {
            that.connectNum = 1;
          }
        });
      },
      addData(msgItem) {
        if (msgItem.desc || msgItem.imageSrc) {
          this.problemList.push(msgItem);
        }
        this.toBottom();
      },
      addData1(message, type) {
        let that = this;
        let msgItem = {
          type: 1,
          desc: [],
          imageSrc: [],
          status:
            message.ai && message.ai.stream && message.ai.stream.status
              ? message.ai.stream.status
              : 0,
          chooseIdx: 0,
          showMore: false,
          showBottom: true,
          dataTime: message.ts * 1000,
          id: message.id,
          chatId: that.chatItem && that.chatItem.id,
        };

        const isExist = that.problemList.find(
          (item) => item.id === msgItem.id && item.chatId == msgItem.chatId
        );
        console.log("msg-isExist", isExist);
        if (
          (message.msg && message.msg.text) ||
          (message.msg && message.msg.image)
        ) {
          if (isExist) {
            const idx = that.problemList.findIndex(
              (item) => item.id === msgItem.id && item.chatId == msgItem.chatId
            );
            if (message.msg && message.msg.text) {
              let tempText = {
                info: message.msg.text,
                descId: uuid(),
              };
              isExist.desc.push(tempText);
            }
            if (message.msg && message.msg.image) {
              isExist.imageSrc.push(message.msg.image);
            }
            that.problemList[idx] = isExist;
            that.$set(that.problemList, idx, isExist);
          } else {
            if (message.msg && message.msg.text) {
              let tempText = {
                info: message.msg.text,
                descId: uuid(),
              };
              msgItem.desc.push(tempText);
            }
            if (message.msg && message.msg.image) {
              msgItem.imageSrc.push(message.msg.image);
            }
            console.log("msgItem", msgItem);
            // const idx = that.problemList.findIndex(
            //   (item) => item.id === msgItem.id && item.chatId == msgItem.chatId
            // );
            that.problemList.push(msgItem);
          }
        }
        console.log("problemList", that.problemList);
        if (type == 2) {
          that.streamStatus = 4;
          // that.chatItem = null;
          // setTimeout(() => {
          // 	that.getUserInfo(true);
          // },2000);
          that.$message({
            message: "回复完成，您可以继续提问了",
            type: "success",
          });
        }
        that.toBottom();
      },
      //进入重新连接
      reconnect() {
        console.log("进入断线重连");
        let that = this;
        if (!that.isOpen) {
          that.socketTask && that.socketTask.close();
          that.socketTask = null;
          if (that.connectInter) {
            clearInterval(that.connectInter);
            that.connectInter = null;
          }
          that.connectSocket();
        }
      },
      sendSocketMessage(msg, isUser = false) {
        console.log("发送信息", msg);
        let self = this;
        // console.log(msg)
        return new Promise((reslove, reject) => {
          self.socketTask.send(msg);
          // self.socketTask.send({
          //   data: msg,
          //   success(res) {
          //     console.log("发送成功");
          //     self.isCanClick = true;
          //     if (isUser) {
          //       self.streamStatus = 0;
          //       setTimeout(() => {
          //         self.getUserInfo(true);
          //       }, 2000);
          //     }

          //     reslove(res);
          //   },
          //   fail(res) {
          //     self.streamStatus = -1;
          //     console.log("发送失败");
          //     console.log(res);
          //     self.$message({
          //       message: "消息发送失败，请稍后重试",
          //       type: "error",
          //     });
          //     if (isUser) {
          //       setTimeout(() => {
          //         self.getUserInfo(true);
          //       }, 2000);
          //     }
          //     self.isCanClick = true;
          //     reject(res);
          //   },
          // });
        });
      },
      //心跳
      heart() {
        let that = this;
        clearInterval(that.timer);
        that.timer = "";
        let ts = Date.now();
        const packet = pb.Packet.create({
          id: uuid(),
          ts: ts,
          cmd: 2,
        });
        const bin = pb.Packet.encode(packet).finish();
        const buffer = bin.buffer.slice(
          bin.byteOffset,
          bin.byteOffset + bin.byteLength
        );
        that.timer = setInterval(() => {
          if (that.isOpen) {
            that
              .sendSocketMessage(buffer)
              .then((res) => {
                console.log("心跳成功");
              })
              .catch((res) => {
                console.log("发送失败");
                console.log(res);
                that.$message({
                  message: "消息发送失败，请稍后重试",
                  type: "error",
                });
              });
          }
        }, 25000);
      },
      chooseModel(val) {
        if (this.streamStatus >= 0 && this.streamStatus != 4) {
          this.showModal = true;
          this.tempItem = val;
          return;
        }
        this.$bus.$emit("clearText");
        this.initChooseType(val);
      },
      initChatModal() {
        if (this.userInfo && this.userInfo.character) {
          let careerChooseIdx = this.problemDefalutList1[0].children.findIndex(
            (res) => {
              return res.type == this.userInfo.character;
            }
          );
          console.log("careerChooseIdx", careerChooseIdx);
          if (careerChooseIdx >= 0) {
            this.careerChooseIdx = careerChooseIdx + 1;
            this.problemDefalutList1[0]["chooseIdx"] =
              Number(careerChooseIdx) - 1;
            this.problemDefalutList1[1] = {
              type: 2,
              desc: "请在助手列表中，选择对应的助手",
              chooseIdx: -1,
              children: [],
            };
            this.getChatModelsReq();
          }
        }
      },
      initChooseType(val) {
        this.currentModalItem = val.item;
        this.problemDefalutList1[val.problemIdx]["chooseIdx"] = val.idx;
        this.modelIdx = val.idx;
        this.currentTypeItem = this.modelsList[val.idx];

        localStorage.setItem(
          "modelChooseIdx",
          (this.currentModalItem && this.currentModalItem.id) || ""
        );
        this.modelChooseIdx = localStorage.getItem("modelChooseIdx") || "";
        this.initChat();
        this.toBottom();
      },
      initChat(msg, isFirst = true) {
        let loading = this.$loading({
          lock: true,
          text: "创建聊天...",
          spinner: "el-icon-loading",
          background: "rgba(0, 0, 0, 0.7)",
        });
        let param = {
          ai_id: this.currentTypeItem && this.currentTypeItem.ai_id,
          model: (this.currentTypeItem && this.currentTypeItem.model) || "",
          type: this.currentTypeItem && this.currentTypeItem.type,
        };
        let currentChatItem = localStorage.getItem("currentChatItem");
        if (currentChatItem) {
          currentChatItem = JSON.parse(currentChatItem);
          if (currentChatItem && currentChatItem.id) {
            localStorage.setItem("currentChatItem", "");
            closeChat({ id: currentChatItem.id }).then((res) => { });
          }
        }
        this.isGetMessage = false;
        this.problemList = [];
        this.streamStatus = -1;
        createChat(param)
          .then((res) => {
            console.log("res", res);
            if (res && res.error == 0) {
              this.chatItem = res.data || null;
              // localStorage.setItem("currentChatItem", JSON.stringify(this.chatItem));
              this.initModel(this.chatItem && this.chatItem.type);
              if (
                this.chatItem &&
                (this.chatItem.type == 0 || this.chatItem.type == 1) &&
                isFirst
              ) {
                this.getChatTipMessagesReq();
              } else {
                this.problemTips[0]["children"] = [];
                this.problemTips[0]["chooseIdx"] = -1;
              }
              if (this.chatItem && this.chatItem.id && msg) {
                this.sendMessage(msg);
              }
            } else {
              this.$message({
                message: (res && res.msg) || "创建聊天失败，请稍后重试",
                type: "error",
              });
            }

            loading.close();
          })
          .catch((err) => {
            loading.close();
            this.$message({
              message: (err && err.msg) || "创建聊天失败，请稍后重试",
              type: "error",
            });
          });
      },
      initModel(idx) {
        console.log("initModel", idx);
        this.showCyAsk = true;
      },
      getChatTipMessagesReq() {
        if (this.chatItem && this.chatItem.id) {
          if (this.chatItem.type == 1) {
            this.problemTips[0]["name"] =
              "我是您的文学创作工具，我可以根据你的描述来帮你讲故事。";
          } else {
            this.problemTips[0]["name"] =
              "我是你的育儿工具，你可以问我关于育儿的知识。我将会给你提供专业的育儿建议。";
          }
          this.problemTips[0]["children"] = [];
          this.problemTips[0]["chooseIdx"] = -1;
          getChatTipMessages(this.chatItem.id)
            .then((res) => {
              console.log("res", res);
              if (res && res.error == 0) {
                if (
                  res &&
                  res.data &&
                  res.data.messages &&
                  res.data.messages.length > 4
                ) {
                  this.problemTips[0]["children"] = res.data.messages.subString(
                    0,
                    4
                  );
                } else {
                  this.problemTips[0]["children"] =
                    (res && res.data.messages) || [];
                }
              } else {
                this.$message({
                  message: (err && err.msg) || "获取推荐数据失败，请稍后重试",
                  type: "error",
                });
              }

              this.toBottom();
            })
            .catch((err) => {
              this.$message({
                message: (err && err.msg) || "获取推荐数据失败，请稍后重试",
                type: "error",
              });
            });
        }
      },
      async sendMessage(msg, hash, imageSrc, id) {
        console.log("isCanClick",this.isCanClick)
        if (!this.isCanClick) {
          return;
        }
        if (this.streamStatus >= 0 && this.streamStatus != 4) {
          this.$message({
            message: "您已经提问，请等待回复!",
            type: "error",
          });
          return;
        }
        this.isCanClick = false;
        let sendMsg = {};
        if (msg) {
          sendMsg["text"] = msg;
        }
        if (hash) {
          sendMsg["image"] = hash;
        }
        if (this.chatItem && this.chatItem.id) {
          console.log("uuid", id, "this.userInfo", this.userInfo);
          id = id || uuid();
          const message = pb.Message.create({
            id: id,
            chatId: this.chatItem && this.chatItem.id,
            cmd: 0,
            type: this.currentTypeItem && this.currentTypeItem.type,
            msg: sendMsg,
            user: {
              id: (this.userInfo && this.userInfo.id) || "",
              dev_id: "browser",
            },
            ts: Date.now() / 1000,
            cat: 0,
            stream: {
              status: 0,
            },
            ai: {
              id: this.currentTypeItem && this.currentTypeItem.ai_id,
              model: this.currentTypeItem && this.currentTypeItem.model,
            },
          });
          console.log("message", message);
          let ts = Date.now();
          const packet = pb.Packet.create({
            id: message.id,
            cmd: 0,
            ts: ts,
            msg: message,
          });
          console.log(packet);
          const bin = pb.Packet.encode(packet).finish();
          const buffer = bin.buffer.slice(
            bin.byteOffset,
            bin.byteOffset + bin.byteLength
          );
          let msgItem = {
            type: 3,
            desc: msg,
            status: 1,
            chooseIdx: 0,
            showMore: false,
            showBottom: false,
            dataTime: ts,
            id: message.id,
            chatId: this.chatItem && this.chatItem.id,
          };
          if (hash) {
            msgItem["imageSrc"] = imageSrc;
            msgItem["image"] = hash;
          }
          if (this.userInfo  && this.userInfo.coin < 100) {
            this.currentMessage = msgItem;
            MessageBox.confirm("积分不够，请前往充值", "提示", {
              confirmButtonText: "确定",
              cancelButtonText: "取消",
              type: "warning",
            })
            .then(() => {
              this.showStationList = true;
              return;
            })
            .catch(() => {
              return;
            });
            return;
          }
          
          this.$bus.$emit("clearText");
          this.toBottom();
          this.tempProblemList = [];
          this.tempProblemList.push(msgItem);
          this.sendSocketMessage(buffer, true);
          this.messages.push(this.currentMessage);
          this.currentMessage = "";
        }
      },
      changeDefaultIdx(val) {
        this.isGetMessage = false;

        if (val.problemIdx == 1) {
          if (this.streamStatus >= 0 && this.streamStatus != 4) {
            this.showModal = true;
            this.tempItem = val;
            return;
          }
          let firstLogin = localStorage.getItem("firstLogin") || 0;
          if (firstLogin == 1) {
            this.showPopup = true;
          }

          // if (val.idx != this.typeIdx) {
          // 	this.initChooseType(val);
          // }
          this.initChooseType(val);
        } else {
          userUpdateProfile({
            character:
              this.problemDefalutList1[val.problemIdx].children[val.idx].type,
          }).then((res) => {
            console.log("userUpdateProfile", res);
          });
          this.problemDefalutList1[val.problemIdx]["chooseIdx"] = val.idx;
          localStorage.setItem("careerChooseIdx", val.idx + 1);
          this.careerChooseIdx = localStorage.getItem("careerChooseIdx") || 0;
          this.problemDefalutList1[1] = {
            type: 2,
            desc: "请在助手列表中，选择对应的助手",
            chooseIdx: -1,
            children: [],
          };
          this.getChatModelsReq();
        }
      },
      toBottom() { 
        this.$nextTick(() => {
					// 获取滚动区域的高度
					let chatRoom = document.querySelector('.center-default-box');
          this.$refs.mainScroll.scrollTo({
            top: chatRoom.scrollHeight + 100,
            behavior: 'smooth'
          })
				});
      },
    },
  };
</script>
<style lang="less" scoped>
  .container {
    height: 100%;
    display: flex;
    /* 禁止文字选择 */
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;

    .menu-layer {
      position: fixed;
      left: 0;
      right: 0;
      top: 0;
      bottom: 0;
      background: transparent;
      z-index: 999;
    }

    .content-box {
      display: flex;
      padding-top: 128px;
      flex: 1;

      .left-box {
        width: 450px;
        display: flex;
      }

      .center-box {
        flex: 1;
        display: flex;
        min-width: 670px;
        position: relative;
        .center-default-box {
          width: 100%;
          margin-bottom: 20px;
          display: flex;
          background: #f8f8fa;
          border-radius: 20px;
          flex-direction: column;
          position: relative;
          overflow-y: auto;
          padding-bottom: 100px;
          .problem-wrap {
            margin-top: 20px;
          }
        }
      }

      .right-box {
        width: 300px;
        display: flex;
      }
    }

    .zhuanfa-popup {
      position: absolute;
      left: 0;
      right: 0;
      bottom: 0;
      padding: 15px 30px 25px 30px;
      background: rgba(243, 243, 248, 0.8);
      box-shadow: inset 0 1px 0 0 #e7e8ed;
      backdrop-filter: blur(10px);
      z-index: 10003;
    }

    .content-detail-popup {
      position: absolute;
      top: 0;
      right: 0;
      bottom: 0;
      left: 0;
      display: flex;
      background: #f8f8fa;
      border-radius: 20px;
      flex-direction: column;
      z-index: 1;
    }
  }
</style>